import { RouteAlias } from './core/models/route-alias.model';
import { RouteType } from './core/models/route-type.enum';
import { aboutResolver } from './pages/about/service/about.resolver';
import { AboutService } from './pages/about/service/about.service';
import { ArticleResolver } from './pages/article/services/article.resolver';
import { ArticleService } from './pages/article/services/article.service';
import { cityOfHealthResolver } from './pages/city-of-health/service/city-of-health.resolver';
import { CityOfHealthService } from './pages/city-of-health/service/city-of-health.service';
import { ContentPagesResolver } from './pages/content/services/content-pages.resolver';
import { ContentPagesService } from './pages/content/services/content-pages.service';
import { DoctorSelectionResolver } from './pages/doctor-selection/services/doctor-selection.resolver';
import { DoctorResolver } from './pages/doctor/services/doctor.resolver';
import { DoctorService } from './pages/doctor/services/doctor.service';
import { EventResolver } from './pages/event/services/event.resolver';
import { EventService } from './pages/event/services/event.service';
import { HomeResolver } from './pages/home/services/home.resolver';
import { HomeService } from './pages/home/services/home.service';
import { HospitalResolver } from './pages/hospital/services/hospital.resolver';
import { HospitalService } from './pages/hospital/services/hospital.service';
import { hotelPageResolver } from './pages/hotel-page/services/hotel-page.resolver';
import { HotelPageService } from './pages/hotel-page/services/hotel-page.service';
import { InternalDepartmentResolver } from './pages/internal-department/services/internal-department.resolver';
import { InternalDepartmentService } from './pages/internal-department/services/internal-department.service';
import { LobbyResolver } from './pages/lobby/services/lobby.resolver';
import { LobbyService } from './pages/lobby/services/lobby.service';
import { locationsResolver } from './pages/locations/services/locations.resolver';
import { LocationsService } from './pages/locations/services/locations.service';
import { SearchResultResolver } from './pages/search-result/services/search-result.resolver';
import { SearchResultService } from './pages/search-result/services/search-result.service';
import { transparencyResolver } from './pages/transparency/services/transparency.resolver';
import { TransparencyService } from './pages/transparency/services/transparency.service';

export const routeAliasTypes: RouteAlias[] = [
  {
    alias: 'internalDepartmentContainer',
    loadComponent: () =>
      import('./pages/internal-department/internal-department.component').then((x) => x.InternalDepartmentComponent),
    providers: [InternalDepartmentService],
    resolve: { data: InternalDepartmentResolver },
    type: RouteType.Container
  },
  {
    alias: 'hospital',
    loadComponent: () => import('./pages/hospital/hospital.component').then((x) => x.HospitalComponent),
    providers: [HospitalService],
    resolve: { data: HospitalResolver },
    type: RouteType.Page
  },
  {
    alias: 'globalSearchPage',
    loadComponent: () => import('./pages/search-result/search-result.component').then((x) => x.SearchResultComponent),
    providers: [SearchResultService],
    resolve: { data: SearchResultResolver },
    type: RouteType.Page
  },
  {
    alias: 'doctorsContainer',
    loadComponent: () => import('./pages/doctor/doctor.component').then((x) => x.DoctorComponent),
    providers: [DoctorService],
    resolve: { data: DoctorResolver },
    type: RouteType.Container
  },
  {
    alias: 'eventContainer',
    loadComponent: () => import('./pages/event/event.component').then((x) => x.EventComponent),
    providers: [EventService],
    resolve: { data: EventResolver },
    type: RouteType.Container
  },
  {
    alias: 'contentPageContainer',
    loadComponent: () => import('./pages/content/content-pages.component').then((x) => x.ContentPagesComponent),
    providers: [ContentPagesService],
    resolve: { data: ContentPagesResolver },
    type: RouteType.Container
  },
  {
    alias: 'articleContainer',
    loadComponent: () => import('./pages/article/article.component').then((x) => x.ArticleComponent),
    providers: [ArticleService],
    resolve: { data: ArticleResolver },
    type: RouteType.Container
  },
  {
    alias: 'doctorSelectionContainer',
    loadComponent: () =>
      import('./pages/doctor-selection/doctor-selection.component').then((x) => x.DoctorSelectionComponent),
    resolve: { data: DoctorSelectionResolver },
    type: RouteType.Container
  },
  {
    alias: 'homePage',
    loadComponent: () => import('./pages/home/home.component').then((x) => x.HomeComponent),
    providers: [HomeService],
    resolve: { data: HomeResolver },
    type: RouteType.Page
  },
  {
    alias: 'locationsPage',
    loadComponent: () => import('./pages/locations/locations.component').then((x) => x.LocationsComponent),
    providers: [LocationsService],
    resolve: { data: locationsResolver },
    type: RouteType.Page
  },
  {
    alias: 'transparencyPage',
    loadComponent: () => import('./pages/transparency/transparency.component').then((c) => c.TransparencyComponent),
    providers: [TransparencyService],
    resolve: { data: transparencyResolver },
    type: RouteType.Page
  },
  {
    alias: 'hotelPage',
    loadComponent: () => import('./pages/hotel-page/hotel-page.component').then((x) => x.HotelPageComponent),
    providers: [HotelPageService],
    resolve: { data: hotelPageResolver },
    type: RouteType.Page
  },
  {
    alias: 'aboutPage',
    loadComponent: () => import('./pages/about/about.component').then((x) => x.AboutComponent),
    providers: [AboutService],
    resolve: { data: aboutResolver },
    type: RouteType.Page
  },
  {
    alias: 'healthCityPage',
    loadComponent: () => import('./pages/city-of-health/city-of-health.page').then((x) => x.CityOfHealthPage),
    providers: [CityOfHealthService],
    resolve: { data: cityOfHealthResolver },
    type: RouteType.Page
  },
  {
    alias: 'lobbiesContainer',
    loadComponent: () =>
      import('./pages/lobby/lobby.component').then((x) => x.LobbyComponent),
    providers: [LobbyService],
    resolve: { data: LobbyResolver },
    type: RouteType.Container
  },
  {
    alias: 'hotelsContainer',
    loadComponent: () =>
      import('./pages/hotel-page/hotel-page.component').then((x) => x.HotelPageComponent),
    providers: [HotelPageService],
    resolve: { data: hotelPageResolver },
    type: RouteType.Container
  }
];
